<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="6">
                <span>搜索: </span>
                <el-autocomplete
                    class="input-with-sd"
                    :size="form.attr && form.attr.size ? form.attr.size : ''"
                    v-model="keyword"
                    value-key="name"
                    :trigger-on-focus="false"
                    :fetch-suggestions="querySearch"
                    popper-class="my-autocomplete"
                    placeholder="请输入关键词查找"
                    @select="handleSelect">
                    <template #default="{ item }">
                        <div class="li">
                            <div class="value">{{ item.name }}</div>
                            <span class="link">{{ item.province }}</span>
                        </div>
                    </template>
                </el-autocomplete>
            </el-col>
            <el-col :span="8">
                <span>地址: </span>
                <el-input
                    class="input-with-sd"
                    v-model="addressObj.value"
                    :name="`${form.name}_address`"
                    :size="form.attr && form.attr.size ? form.attr.size : ''">
                </el-input>
            </el-col>
            <el-col :span="6">
                <span>坐标: </span>
                <el-input
                    class="input-with-sd"
                    v-model="form.value"
                    :name="form.name"
                    :size="form.attr && form.attr.size ? form.attr.size : ''">
                </el-input>
            </el-col>
        </el-row>

        <baidu-map
            :style="{ width: form.attr && form.attr.width ? form.attr.width : '', height: form.attr && form.attr.height ? form.attr.height : ''}"
            class="map"
            :ak="form.ak"
            :scroll-wheel-zoom="false"
            :center="point"
            :zoom="zoom"
            @ready="initMap"
            @click="clickMap"
            @moveend="dragendMarker"
            @zoomend="zoomendMap">
            <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
            <bm-marker :position="point" :dragging="true" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
        </baidu-map>
    </div>
</template>
<script>
    import { getCurrentInstance, defineComponent, ref, provide, inject, watch } from 'vue'
    import { BaiduMap, BmNavigation, BmMarker, useGeocoder, getAddressByPoints, getPointByAddress } from 'vue-baidu-map-3x'
    export default defineComponent({
        components: {
            BaiduMap,
            BmNavigation,
            BmMarker
        },
        props: {
            forms: {
                type: [Array, Object],
                default: () => {}
            },
            formobj: {
                type: [Array, Object],
                default: () => {}
            }
        },
        setup(props, context) {
            const { proxy } = getCurrentInstance()
            const form = ref(props.forms)
            const forms = ref(props.formobj)
            const addressObj = ref({
                name: form.value.name + '_address',
                value: form.value.address
            })
            forms.value.push(addressObj.value)
            const point = ref({ lng: 116.404, lat: 39.915 })
            if (form.value.value) {
                let arr = form.value.value.split(',')
                point.value.lng = arr[0]
                point.value.lat = arr[1]
            }
            form.value.value = point.value.lng + ',' + point.value.lat
            const zoom = ref(form.value.level)
            const keyword = ref()
            const city = ref()
            const clickMap = (e) => {
                useGeocoder().then((geocoder) => {
                    geocoder.getLocation(e.point, (res) => {
                        addressObj.value.value = res.address
                    })
                })
                const { name } = e.target.getCurrentCity()
                if (name) {
                    city.value = name
                }
                point.value = e.point
                form.value.value = e.point.lng + ',' + e.point.lat
            }
            const dragendMarker = (e) => {
                const { name } = e.target.getCurrentCity()
                if (name) {
                    city.value = name
                }
            }
            const zoomendMap = (e) => {
                zoom.value = e.target.getZoom()
            }

            const initMap = () => {
                zoom.value = ref(form.value.level)
                let arr = form.value.value.split(',')
                point.value.lng = arr[0]
                point.value.lat = arr[1]
            }

            const querySearch = (query, cb) => {
                if (query.length > 0) {
                    getSearch(query).then((e) => {
                        cb(e)
                    })
                }
            }
            const handleSelect = (e) => {
                point.value = e.location
                addressObj.value.value = e.address + e.name
                form.value.value = e.location.lng + ',' + e.location.lat
            }
            const getSearch = (query) => {
                return new Promise((resolve, reject) => {
                    proxy.jiu.jsonp(`https://api.map.baidu.com/place/v2/search?query=${query}&region=${city.value}&output=json&ak=${form.value.ak}`).then((res, rej) => {
                        resolve(res.results)
                    }).catch((error) => {
                        reject(error)
                    })
                })
            }

            return {
                zoom,
                point,
                form,
                keyword,
                addressObj,
                initMap,
                clickMap,
                dragendMarker,
                zoomendMap,
                querySearch,
                handleSelect
            }
        }
    })
</script>

<style>
    .map {
        width: 100%;
        height: 400px;
        margin-top: 20px;
    }
    .my-autocomplete .link {
        color: #a9a6ab;
    }
    .my-autocomplete .li {
        border-bottom: 1px solid #f1f1f1;
    }
    .input-with-sd{ width: 70%;}
</style>
